import styled from "styled-components";
import { Button } from "./HeroSession.js/HeroSession.styles";
// import Arrow from "../../../assets/Vector 1.svg";

const GetStarted = () => {
  return (
    <StartWrap>
      <h1>Make your money work for you</h1>
      <p>It’s easy to get started, just hit the button.</p>
      {/* <ArrowWrappper>
        <img src={Arrow} alt="arrow" />
      </ArrowWrappper> */}
      <GetstartedButton>
        <Button to="/product">Get Started</Button>
      </GetstartedButton>
    </StartWrap>
  );
};

export default GetStarted;

export const StartWrap = styled.div`
  overflow-x: hidden;
  position: relative;
  background-color: #dbdbf9;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100vw;
  // border: 8px solid orange;

    h1 {
    text-align: center;
    font-size: 3rem;
    font-family: 'Futura';
    font-weight: 200;
    line-height: 56px;
    margin-bottom: 0rem;
  }
  
  p {
    margin-top: 1rem;
    text-align: center;
    font-size: 20px;
  }
  div {
    display: flex;
    justify-content: center;
  }

  @media screen and (max-width: 991px) {
      // margin-left: 5rem
      // margin-right: 5rem
    }
  @media screen and (max-width: 579px) {
     h1 {
        // margin-left: 5rem
      margin-right: 5rem
      line-height: 56px;
      width: 80%;
      margin: 1rem auto;
     }
      p {
      width: 70%;
      margin:  auto;
    }
    }


`;

export const GetstartedButton = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
  a {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
  }
`;
// export const ArrowWrappper = styled.div`
// position: absolute;
// top: 10.2rem;
// right: 33rem;
//   @media screen and (max-width: 991px) {
//     top: 10rem;
//     right: 17rem;
//     // transform: translate(5rem, -1rem);
//     // margin-left: 2rem
//     // margin-right: 2rem
//   }
//   @media screen and (max-width: 579px) {
//       display: none;
//     }
// `;
